// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Y6-z","paperCutsLineHeight":"Z6-z"};